import {RouteNameEnum} from "@/v2/enumerate/route";

const keyword = [{
	path: "keyword",
	name: RouteNameEnum.GLORY_KEYWORD,
	meta: {
		permission: 68001,
		breadcrumb: [{
			key: "glory.keyword.index",
			value: null
		}]
	},
	component: () => import("@/page/content/glory/keyword/index.vue"),
}];

export default keyword;
